// extracted by mini-css-extract-plugin
export default {"imageOuter":"Advert_imageOuter__0SbDh","image":"Advert_image__lV6eS"};